import Config from 'config/config';

export default {
  generateGroupImageUrl(groupCode, useSmall = false) {
    if (!groupCode) return Config.defaultProfileImage;
    const suffix = useSmall ? Config.groups.smallSuffix : Config.groups.suffix;
    return Config.cdn.communityLogos + groupCode + suffix;
  },
  generateGroupBannerUrl(groupCode) {
    if (!groupCode) return Config.defaultBannerImage;
    return Config.cdn.communityBanners + groupCode + Config.groups.bannerSuffix;
  },
  /**
   * Prep a link for insertion into anchor href
   * @param link
   * @returns String
   */
  prepLink(link) {
    if (!link) return '';

    if (link.indexOf('//') > -1) {
      return link;
    }

    return 'http://' + link;
  },

  generateAvatarLinkFromHash(hash) {
    return !hash
      ? Config.defaultProfileImage
      : Config.cdn.avatars + hash + Config.avatars.smallSuffix;
  },

  generateAvatarLink(user) {
    if (!user || user.isDeleted || (!user.userId && !user.id)) {
      return Config.defaultProfileImage;
    }

    return user.imageUrl
      || user.profileImageSmall
      || (Config.cdn.avatars + user.userImageHash + Config.avatars.smallSuffix);
  },

  generatePromoImageLink(hash) {
    return `${Config.cdn.communityPromoImages}${hash}_378x378.jpg`;
  },
};



// WEBPACK FOOTER //
// ./src/utils/linkUtils.js